import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function expenseDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/expense/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
